import React from 'react';
import { Link } from 'react-router-dom';
import {
  CrossIcon, EditIcon,
  IconButton, Strong, Tooltip,
} from 'evergreen-ui';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  title: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content 1fr',
    justifyItems: 'end',
    alignItems: 'center',
    gridColumnGap: '.2em',
  },
});

type TitleWithCrossProps = {
  title?: string
  crossTooltip?: string
  crossTo?: string
  crossOnClick?: () => void | undefined
}

/**
 * Компонент-Название для страниц с созданием/редактирование
 * @param {string} title название
 * @example <TitleWithCross title="Датчик" crossTooltip="Вернутся к датчикам" crossTo=".." />
<TitleWithCross title="Датчик" crossTooltip="Вернутся к датчикам" crossOnClick={someFucntion} />
 */
export default function TitleWithCross({
  title = '',
  crossTooltip = 'Закрыть',
  crossTo = '',
  crossOnClick = undefined,
}: TitleWithCrossProps) {
  const classes = useStyles();

  return (
    <div className={classes.title}>
      <IconButton appearance="minimal" icon={EditIcon} />
      <Strong>{title}</Strong>
      <Tooltip content={crossTooltip}>
        <IconButton
          is={crossTo ? Link : undefined}
          to={crossTo}
          icon={CrossIcon}
          appearance="minimal"
          intent="none"
          onClick={crossOnClick}
        />
      </Tooltip>
    </div>
  );
}
